import { customerPortal } from "@vilocnv/allsetra-core";
import axiosInstance from "app/axiosInstance";

type PostGeozoneRequestDto = customerPortal.geozones.PostGeozoneRequestDto;

export const postGeozone = async ({
  accountId,
  data
}: PostGeozoneRequestDto) => {
  if (!accountId) return;

  const response = await axiosInstance.post(
    `/accounts/${accountId}/geozones`,
    data
  );

  return response.data;
};
